import { render, staticRenderFns } from "./MdtTable.vue?vue&type=template&id=6c0d8711&scoped=true"
import script from "./MdtTable.vue?vue&type=script&lang=js"
export * from "./MdtTable.vue?vue&type=script&lang=js"
import style0 from "./MdtTable.vue?vue&type=style&index=0&id=6c0d8711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d8711",
  null
  
)

export default component.exports